<div class="popover-erreur-connexion">
  <p class="typo-20-bold-green ion-text-center ion-text-uppercase">Vous n'êtes pas un {{profil}}.</p>
  <p class="typo-20-green ion-text-center" style="white-space: pre-line">{{message}}</p>
  <ion-button class="typo-16-bold-white ion-text-uppercase" (click)="dismiss()">OK</ion-button>
</div>
